import createYDAPI from '@/utils/api'
import createHTTPClient from '@/utils/api/client'
import i18n from '@/utils/plugins/i18n'
import createPermissionChecker from '@/utils/plugins/permissions'

/**
 * Wire router-dependent extensions ($cycloid, $hasRightsTo, $router) into every pinia store.
 * Called from the composition root once the router exists, which keeps @/router out of the
 * store/plugin import graph (see src/router/holder.js).
 *
 * @param {{ pinia: import('pinia').Pinia, router: import('vue-router').Router }} params
 */
export function installStoreExtensions ({ pinia, router }) {
  const ydAPIHTTPClient = createHTTPClient(i18n)
  const permissions = createPermissionChecker(router)
  const ydAPI = createYDAPI(ydAPIHTTPClient, i18n, router)
  pinia.use(({ store }) => {
    store.$cycloid = { permissions, ydAPI }
    store.$hasRightsTo = (...rest) => store.$cycloid.permissions.canDisplay(...rest)
    store.$router = router
  })
}

const storeMap = {
  cyOrgProjectKpi: 'organization.project.kpi',
  'cyLayout.dataTables': 'layout.dataTables',
  'cyLayout.sidebar.collapsed': 'layout.sidebar.collapsed',
  cyAuth: 'auth.socialProvider',
  cyCustomers: 'customers',
}

/**
 * Migrates data from Vuex persistence to new storage format
 * Retrieves Vuex state from localStorage and processes it
 * @returns {void}
 */
export function migrateVuexPersistence () {
  let vuex = null
  try {
    const vuexData = localStorage.getItem('vuex')
    vuex = vuexData ? JSON.parse(vuexData) : null
  } catch (error) {
    console.error('Failed to parse Vuex data from localStorage:', error)
  }
  if (vuex === null) {
    return
  }
  const object = {}
  for (const [key, path] of Object.entries(storeMap)) {
    const value = _.get(vuex, path)
    if (value) {
      _.set(object, key, value)
      _.set(vuex, path, undefined)
    }
  }
  for (const [key, value] of Object.entries(object)) {
    localStorage.setItem(key, JSON.stringify(value))
  }
  localStorage.setItem('vuex', JSON.stringify(vuex))
}
